export const faqCard = () => {
  const faqCards = document.querySelectorAll(".faq-card");

  const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

  faqCards.forEach((faqCard) => {
    if (isTouchDevice) {
      // モバイル: タップで切り替え
      faqCard.addEventListener("click", () => {
        faqCard.classList.toggle("is-active");
      });
    } else {
      // PC: ホバーのみ
      faqCard.addEventListener("mouseenter", () => {
        faqCard.classList.add("is-active");
      });

      faqCard.addEventListener("mouseleave", () => {
        faqCard.classList.remove("is-active");
      });
    }
  });
};
